import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";
import getPlatform from "./getPlatform";

export default createSelector(
  [getPlatform, getUserAgent],
  (platform, userAgent) => {
    const osVersion = parseFloat(platform.os.version);

    return userAgent.isWindows && Math.floor(osVersion) === 7;
  },
);
